import React, {Component} from 'react';
import {connect} from 'react-redux';
import {PropTypes} from 'prop-types';
import RegistrationFormService from '../services/RegistrationFormService';
import ValidateableDropdownField from "./ValidateableDropdownField";
import _map from "lodash/map";
import {getSecurityQuestions} from "../../../store/rootReducer";

class SecurityQuestionDropdown extends Component {
  constructor(props) {
    super(props);
    this.dropdownQuestions = this.getDropdownFormattedSecurityQuestions();
  }

  getDropdownFormattedSecurityQuestions = () => {
    return _map(this.props.securityQuestions, (securityQuestion) => {
      return {
        value: securityQuestion.id,
        en: securityQuestion.en,
        fr: securityQuestion.fr
      }
    });
  };

  validateValue = (value) => {
    return RegistrationFormService.validateSecurityQuestion(value);
  };

  render() {
    return (
        <React.Fragment>
          <ValidateableDropdownField
              fieldLabel={this.props.fieldLabel}
              validationFunction={this.validateValue}
              onChange={this.props.onChange}
              customOptions={this.dropdownQuestions}
              showErrors={this.props.showErrors}
          />
        </React.Fragment>
    )
  }
}

SecurityQuestionDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  fieldLabel: PropTypes.string,
  showErrors: PropTypes.bool
};

const mapStateToProps = (state) => {
  return {
    securityQuestions: getSecurityQuestions(state)
  }
};

export default connect(mapStateToProps)(SecurityQuestionDropdown);